// extracted by mini-css-extract-plugin
export default {"ItemsWrapper":"RecipesDropdown_ItemsWrapper__7PjDq","Slide":"RecipesDropdown_Slide__tKh-l","Active":"RecipesDropdown_Active__YvhCP"};